module.exports = __webpack_public_path__ + "img/facebook.cc4cba12.svg";